
















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ExtraFieldColumnLayout,
  ListColumnLayout,
  TimeEntryExtraFieldDataTypeEnum,
  TimeEntryExtraFieldMetadataViewModel,
  TimeEntryListSettingsModel
} from "@/services/api/nswag/stapiclient_generated";
import SlideIn from "@/components/basic/SlideIn.vue";
import { timeEntryExtraFieldMetadataClient } from "@/services/st-api";
import { UserStore } from "@/store/user-module";

@Component({
  components: { SlideIn }
})
export default class ListColumnEdit extends Vue {
  @Prop() value!: TimeEntryListSettingsModel;

  listSettings: TimeEntryListSettingsModel = TimeEntryListSettingsModel.fromJS({});
  extraFieldsRaw: TimeEntryExtraFieldMetadataViewModel[] = [];

  async mounted() {
    this.extraFieldsRaw = (await timeEntryExtraFieldMetadataClient.getList()) ?? [];
  }

  get extraFields() {
    let res = this.extraFieldsRaw.filter(x => x.dataType == TimeEntryExtraFieldDataTypeEnum.Text);

    res.push(...this.extraFieldsRaw.filter(x => x.dataType != TimeEntryExtraFieldDataTypeEnum.Text));

    return res;
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
    this.listSettings = JSON.parse(JSON.stringify(this.value));
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser;
  }

  getExtraFieldWidth(colId: number) {
    return this.listSettings.extraFieldColumnLayout?.find(x => x.id == colId)?.width;
  }

  setExtraFieldWidth(value: number, colId: number) {
    if (!value) {
      if (this.extraFieldColLayoutExists(colId)) {
        this.listSettings.extraFieldColumnLayout!.splice(this.extraFieldColLayoutIndex(colId), 1);
      } else {
        return;
      }
    } else {
      if (this.extraFieldColLayoutExists(colId)) {
        this.listSettings.extraFieldColumnLayout![this.extraFieldColLayoutIndex(colId)]!.width = value;
      } else {
        this.listSettings.extraFieldColumnLayout?.push(ExtraFieldColumnLayout.fromJS({ id: colId, width: value }));
      }
    }
  }

  extraFieldColLayoutIndex(colId: number) {
    return this.listSettings.extraFieldColumnLayout?.findIndex(x => x.id == colId) ?? -1;
  }

  extraFieldColLayoutExists(colId: number) {
    return this.extraFieldColLayoutIndex(colId) > -1;
  }

  getWidth(colId: string) {
    return this.listSettings.columnLayout?.find(x => x.columnName == colId)?.width;
  }

  setWidth(value: number, colId: string) {
    if (!value) {
      if (this.columnLayoutExists(colId)) {
        this.listSettings.columnLayout!.splice(this.columnLayoutIndex(colId), 1);
      } else {
        return;
      }
    } else {
      if (this.columnLayoutExists(colId)) {
        this.listSettings.columnLayout![this.columnLayoutIndex(colId)]!.width = value;
      } else {
        this.listSettings.columnLayout?.push(ListColumnLayout.fromJS({ columnName: colId, width: value }));
      }
    }
  }

  columnLayoutIndex(colId: string) {
    return this.listSettings.columnLayout?.findIndex(x => x.columnName == colId) ?? -1;
  }

  columnLayoutExists(colId: string) {
    return this.columnLayoutIndex(colId) > -1;
  }

  isNumericExtraField(field: TimeEntryExtraFieldMetadataViewModel) {
    return field.dataType == TimeEntryExtraFieldDataTypeEnum.Decimal ||
      field.dataType == TimeEntryExtraFieldDataTypeEnum.Integer;
  }

  extraFieldColIsVisible(colId: number) {
    return this.extraFieldColIndex(colId) > -1;
  }

  extraFieldColIndex(colId: number) {
    return this.listSettings.visibleExtraFieldIds?.findIndex(x => x == colId) ?? -1;
  }

  toggleExtraFieldCol(colId: number) {
    if (!this.extraFieldColIsVisible(colId)) {
      this.listSettings.visibleExtraFieldIds?.push(colId);
    } else {
      this.listSettings.visibleExtraFieldIds?.splice(this.extraFieldColIndex(colId), 1);
    }
  }

  columnIsVisible(colId: string) {
    return this.columnIndex(colId) == -1;
  }

  columnIndex(colId: string) {
    return this.listSettings.hiddenColumns?.findIndex(x => x == colId) ?? -1;
  }

  toggleColumn(colId: string) {
    if (this.columnIsVisible(colId)) {
      this.listSettings.hiddenColumns?.push(colId);
    } else {
      this.listSettings.hiddenColumns?.splice(this.columnIndex(colId), 1);
    }
  }

  isSpecialCol(colId: string) {
    return this.specialColIds.some(x => x == colId);
  }

  get specialColIds() {
    return ["timefromto", "labels", "additionalfields"];
  }

  get canViewRates(){
    return UserStore.userSettings.CanViewRates;
  }

  //TODO: Wenn sich die Spaltenanzahl verändert, Hack in ListTable.vue numberOfReducingGroups() beachten!!
  get columns(): any[] {
    let res = [
      { id: "date", description: "Datum" },
      { id: "customer", description: "Kunde", hasWidth: true },
      { id: "project", description: "Projekt", hasWidth: true },
      { id: "appuser", description: "Mitarbeiter", hasWidth: true },
      { id: "projecttask", description: "Leistung", hasWidth: true },
      { id: "rate", description: "Stundensatz", hasWidth: true },
      { id: "description", description: "Beschreibung / Details", hasWidth: true },
      { id: "timefromto", description: "Zeit von-bis und Pause" },
      { id: "labels", description: "Kategorien" }
    ];

    if(this.extraFields?.length){
      res.push({ id: "additionalfields", description: "Zusatzfelder" });
    }

    res.push({ id: "duration", description: "Dauer" });

    if(UserStore.userSettings.CanViewRates){
      res.push({ id: "revenue", description: "Umsatz" });
    }

    if(!this.useProjectTimeTracking){
      res = [
        { id: "date", description: "Datum" },
        { id: "appuser", description: "Mitarbeiter", hasWidth: true },
        { id: "description", description: "Beschreibung / Details", hasWidth: true },
        { id: "timefromto", description: "Zeit von-bis und Pause" },
        { id: "duration", description: "Dauer" }
      ];

      if(this.extraFields?.length){
        res.push({ id: "additionalfields", description: "Zusatzfelder" });
      }
    }

    return res;
  }

  save() {
    this.$emit("input", JSON.parse(JSON.stringify(this.listSettings)));
    this.cancel();
  }

  cancel() {
    (this.$refs.slideIn as SlideIn).close();
  }
}
